<template>
  <div class="station-info">
    <div class="station-header">
      <h2 class="station-name">{{ station.name }}</h2>
      <button 
        class="flag-btn"
        :class="{ 'flagged': isFlagged }"
        @click="$emit('toggle-flag')"
        :title="isFlagged ? 'Remove flag' : 'Flag candidate'"
      >
        <span class="flag-icon">🚩</span>
        {{ isFlagged ? 'Flagged' : 'Flag' }}
      </button>
    </div>
    
    <div class="candidate-info">
      <div class="candidate-id">{{ candidate.id }}</div>
      <div class="candidate-name">{{ candidate.name }}</div>
    </div>
    
    <div class="progress-indicator">
      <div class="progress-label">Completion</div>
      <div class="progress-bar">
        <div 
          class="progress-fill"
          :style="{ width: completionPercentage + '%' }"
        ></div>
      </div>
      <div class="progress-text">{{ completionPercentage }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    station: Object,
    candidate: Object,
    isFlagged: Boolean,
    completionPercentage: Number
  }
}
</script>

<style scoped>
.station-info {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background: white;
}

.station-header {
  display: flex;
  justify-content: between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.station-name {
  font-size: 1.2em;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  flex: 1;
}

.flag-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8em;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.flag-btn.flagged {
  background: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.candidate-info {
  margin-bottom: 15px;
}

.candidate-id {
  font-size: 0.9em;
  color: #6c757d;
  font-family: monospace;
}

.candidate-name {
  font-size: 1.1em;
  font-weight: 500;
  color: #495057;
}

.progress-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
}

.progress-label {
  font-size: 0.9em;
  color: #6c757d;
  min-width: 80px;
}

.progress-bar {
  flex: 1;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #28a745;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 0.9em;
  font-weight: 600;
  color: #495057;
  min-width: 40px;
  text-align: right;
}
</style>